import { httpMessage } from "@saleshub/dictionary/http";
import { z } from "zod";
import { withId } from "../../utils/with-id.js";
const actions = {
    create: "create",
    read: "read",
    update: "update",
    delete: "delete",
};
const resources = {
    actions: "actions",
    analytics: "analytics",
    contacts: "contacts",
    elements: "elements",
    experiences: "experiences",
    favorites: "favorites",
    flags: "flags",
    hotspots: "hotspots",
    icons: "icons",
    mediaItems: "mediaItems",
    messages: "messages",
    permissions: "permissions",
    properties: "properties",
    roles: "roles",
    shares: "shares",
    tags: "tags",
    users: "users",
    visualizations: "visualizations",
    categories: "categories",
};
export const permissionsSchema = z.object({
    action: z.nativeEnum(actions, {
        required_error: httpMessage.responses.permissions.required.action,
        invalid_type_error: httpMessage.responses.permissions.invalid.action,
    }),
    resource: z.nativeEnum(resources, {
        required_error: httpMessage.responses.permissions.required.resource,
        invalid_type_error: httpMessage.responses.permissions.invalid.resource,
    }),
});
export const permissionsSchemaWithId = permissionsSchema.merge(withId({
    required_error: httpMessage.responses.permissions.required.id,
    invalid_type_error: httpMessage.responses.permissions.invalid.id,
}));
